module.exports = __webpack_public_path__ + "img/save_money.4611d0b.png";